export default function StarRating({ stars }: { stars: string }) {
  const match = stars.match(/^(\d+)(s?)$/);
  if (!match) return null;

  const count = parseInt(match[1], 10);
  const hasS = match[2] === "s";

  return (
    <span className="message-template-stars">
      {Array.from({ length: count }, (_, i) => (
        <span key={i} style={{ fontSize: "1rem", lineHeight: 1 }}>
          *
        </span>
      ))}
      {hasS && (
        <span
          style={{
            fontSize: "0.7rem",
            lineHeight: 1,
            marginLeft: "1px",
            verticalAlign: "top",
          }}
        >
          s
        </span>
      )}
    </span>
  );
}
